var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowUpPoint = function SvgArrowUpPoint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.33 6.702a.427.427 0 0 0-.144-.149.354.354 0 0 0-.371 0 .427.427 0 0 0-.143.149l-3.6 6.066a.532.532 0 0 0-.026.482.446.446 0 0 0 .147.183.358.358 0 0 0 .207.067h7.2a.36.36 0 0 0 .207-.068.447.447 0 0 0 .147-.183.534.534 0 0 0-.024-.481l-3.6-6.066Z",
    fill: "#666"
  })));
};
export default SvgArrowUpPoint;